import { Action, MetaReducer, createReducer } from '@ngrx/store';
import { HttpStateHandler } from '@shared/utils/classes/http-state-handler';
import { produceOn, transferStateMetaReducer } from '@shared/utils/functions/store.function';
import { HttpState } from '@shared/utils/models/http.model';
import {
  PublicDemandFormDetails,
  SendPublicDemandFormResponse,
} from '@features/public-demand-form/utils/models/public-demand-form.model';
import { PublicDemandFormActions, PublicDemandFormResetActions } from '../actions/public-demand-form.actions';

export const publicDemandFormFeatureKey = 'publicDemandForm';

export interface State {
  userId: number | null;
  data: PublicDemandFormDetails | null;
  httpState: HttpState;
  send: {
    httpState: HttpState;
    data: SendPublicDemandFormResponse | null;
  };
}

export const initialState: State = {
  userId: null,
  data: null,
  httpState: HttpStateHandler.initialState,
  send: {
    httpState: HttpStateHandler.initialState,
    data: null,
  },
};

export const publicDemandFormReducer = createReducer(
  initialState,
  produceOn(PublicDemandFormActions.validateDemandForm, (draft, action) => {
    draft.userId = action.userId;
    draft.data = initialState.data;
    draft.httpState = HttpStateHandler.loading(draft.httpState, action);
  }),
  produceOn(PublicDemandFormActions.validateDemandFormSuccess, (draft, action) => {
    draft.data = action.data;
    draft.httpState = HttpStateHandler.success(draft.httpState, action);
  }),
  produceOn(PublicDemandFormActions.validateDemandFormFailure, (draft, action) => {
    draft.httpState = HttpStateHandler.error(draft.httpState, action);
  }),
  produceOn(PublicDemandFormActions.sendDemandForm, (draft, action) => {
    draft.send.data = initialState.send.data;
    draft.send.httpState = HttpStateHandler.loading(draft.send.httpState, action);
  }),
  produceOn(PublicDemandFormActions.sendDemandFormSuccess, (draft, action) => {
    draft.send.data = action.data;
    draft.send.httpState = HttpStateHandler.success(draft.send.httpState, action);
  }),
  produceOn(PublicDemandFormActions.sendDemandFormFailure, (draft, action) => {
    draft.send.httpState = HttpStateHandler.error(draft.send.httpState, action);
  }),
  produceOn(PublicDemandFormResetActions.cancelPublicDemandFormActionsSuccess, (draft) => {
    draft.httpState = HttpStateHandler.initialState;
  }),
  produceOn(PublicDemandFormResetActions.resetPublicDemandForm, (draft) => {
    draft.userId = initialState.userId;
    draft.data = initialState.data;
    draft.httpState = initialState.httpState;
    draft.send = initialState.send;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return publicDemandFormReducer(state, action);
}

export const metaReducers: MetaReducer<State>[] = [
  transferStateMetaReducer(publicDemandFormFeatureKey, initialState, false),
];
